function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import t from "@swup/plugin";
import { Location as e, getCurrentUrl as r } from "swup";
function o(t, r) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$stripEmptyParams = _ref.stripEmptyParams,
    o = _ref$stripEmptyParams === void 0 ? !1 : _ref$stripEmptyParams;
  var s = n("method", t, r),
    i = n("enctype", t, r),
    a = "multipart/form-data" === i,
    u = n("target", t, r, ""),
    _e$fromUrl = e.fromUrl(n("action", t, r)),
    m = _e$fromUrl.origin,
    c = _e$fromUrl.href,
    l = new FormData(t, r);
  var h, f;
  if ("POST" === s && (h = a ? l : new URLSearchParams(l)), "GET" === s) {
    var _t = o ? function (t) {
      var e = new FormData();
      for (var _i = 0, _Array$from = Array.from(t.entries()); _i < _Array$from.length; _i++) {
        var _Array$from$_i = _slicedToArray(_Array$from[_i], 2),
          _r = _Array$from$_i[0],
          _o = _Array$from$_i[1];
        "" !== _o && e.append(_r, _o);
      }
      return e;
    }(l) : l;
    f = function (t, e) {
      var _ref2 = [].concat(_toConsumableArray(t.split(/(?=#)/)), [""]),
        r = _ref2[0],
        o = _ref2[1],
        n = r.split("?")[0],
        s = new URLSearchParams(e).toString();
      return s ? "".concat(n, "?").concat(s).concat(o) : n + o;
    }(c, _t);
  } else f = c;
  var _e$fromUrl2 = e.fromUrl(f),
    p = _e$fromUrl2.url,
    d = _e$fromUrl2.hash;
  return {
    origin: m,
    action: c,
    href: f,
    url: p,
    hash: d,
    method: s,
    target: u,
    data: l,
    body: h,
    encoding: i
  };
}
function n(t, e, o, n) {
  var _ref3, _o$getAttribute;
  return function (t, e) {
    switch (t) {
      case "action":
        return e !== null && e !== void 0 ? e : r();
      case "method":
        return (e || "get").toUpperCase();
      case "enctype":
        return (e || "application/x-www-form-urlencoded").toLowerCase();
      default:
        return e !== null && e !== void 0 ? e : null;
    }
  }(t, (_ref3 = (_o$getAttribute = o === null || o === void 0 ? void 0 : o.getAttribute("form".concat(t))) !== null && _o$getAttribute !== void 0 ? _o$getAttribute : e.getAttribute(t)) !== null && _ref3 !== void 0 ? _ref3 : n);
}
var s = /*#__PURE__*/function (_t2) {
  function s() {
    var _this;
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, s);
    _this = _callSuper(this, s), _this.name = "SwupFormsPlugin", _this.requires = {
      swup: ">=4"
    }, _this.defaults = {
      formSelector: "form[data-swup-form]",
      inlineFormSelector: "form[data-swup-inline-form]",
      stripEmptyParams: !1
    }, _this.options = void 0, _this.specialKeys = void 0, _this.formSubmitDelegate = void 0, _this.prepareInlineForms = function (t) {
      var e = t.trigger.el;
      if (!(e !== null && e !== void 0 && e.matches(_this.options.inlineFormSelector))) return;
      if (!e.id) return void console.error("[@swup/forms-plugin] inline forms must have an id attribute:", e);
      var r = "#".concat(e.id);
      t.containers = [r], t.animation.scope = "containers", t.animation.selector = r, t.scroll.target = r;
      var o = t.a11y;
      "object" == _typeof(o) && (o.focus = r);
    }, _this.options = _objectSpread(_objectSpread({}, _this.defaults), t), _this.specialKeys = function (t) {
      var e = {};
      function r() {
        e = {};
      }
      function o(_ref4) {
        var r = _ref4.key;
        t.includes(r) && (e[r] = !0);
      }
      function n(_ref5) {
        var r = _ref5.key;
        t.includes(r) && (e[r] = !1);
      }
      function s() {
        r();
      }
      return {
        watch: function watch() {
          document.addEventListener("keydown", o), document.addEventListener("keyup", n), window.addEventListener("blur", s);
        },
        unwatch: function unwatch() {
          document.removeEventListener("keydown", o), document.removeEventListener("keyup", n), document.removeEventListener("blur", s), r();
        },
        get pressed() {
          return Object.values(e).filter(Boolean).length > 0;
        }
      };
    }(["Meta", "Control", "Shift"]), _this.beforeFormSubmit = _this.beforeFormSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }
  _inherits(s, _t2);
  return _createClass(s, [{
    key: "mount",
    value: function mount() {
      this.swup.hooks.create("form:submit"), this.swup.hooks.create("form:submit:newtab"), this.specialKeys.watch(), this.formSubmitDelegate = this.swup.delegateEvent(this.options.formSelector, "submit", this.beforeFormSubmit, {
        capture: !0
      }), this.on("visit:start", this.prepareInlineForms, {
        priority: 1
      });
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var _this$formSubmitDeleg;
      (_this$formSubmitDeleg = this.formSubmitDelegate) !== null && _this$formSubmitDeleg !== void 0 && _this$formSubmitDeleg.destroy(), this.specialKeys.unwatch();
    }
  }, {
    key: "beforeFormSubmit",
    value: function beforeFormSubmit(t) {
      var _this2 = this;
      var e = this.swup,
        r = t.delegateTarget,
        n = t.submitter,
        _o2 = o(r, n),
        _s = _o2.href,
        i = _o2.url,
        a = _o2.hash,
        u = _o2.target,
        m = this.specialKeys.pressed,
        c = "_blank" === u,
        l = m || c,
        h = e.createVisit({
          to: i,
          hash: a,
          el: r,
          event: t
        });
      if (l || !e.shouldIgnoreVisit(_s, {
        el: r,
        event: t
      })) if (c) e.hooks.callSync("form:submit:newtab", h, {
        el: r,
        event: t
      });else if (m) {
        e.hooks.callSync("form:submit:newtab", h, {
          el: r,
          event: t
        });
        var _o3 = function (t) {
          var e = t.getAttribute("target") || "";
          return t.setAttribute("target", "_blank"), function () {
            e ? t.setAttribute("target", e) : t.removeAttribute("target");
          };
        }(r);
        r.addEventListener("submit", function () {
          return setTimeout(_o3);
        }, {
          once: !0
        });
      } else e.hooks.callSync("form:submit", h, {
        el: r,
        event: t
      }, function () {
        _this2.submitForm(t);
      });
    }
  }, {
    key: "submitForm",
    value: function submitForm(t) {
      var e = t.delegateTarget,
        r = t.submitter,
        n = this.options.stripEmptyParams,
        _o4 = o(e, r, {
          stripEmptyParams: n
        }),
        _s2 = _o4.href,
        i = _o4.method,
        a = _o4.body;
      ["GET", "POST"].includes(i) ? (t.preventDefault(), this.swup.navigate(_s2, {
        method: i,
        body: a,
        cache: {
          read: !1,
          write: !0
        }
      }, {
        el: e,
        event: t
      })) : console.warn("Unsupported form method: ".concat(i));
    }
  }]);
}(t);
export { s as default };